import { useSyncExternalStore } from 'react'

export type Toast = {
  id: number
  message: string
  tone: 'default' | 'error'
  action?: { label: string; onClick: () => void }
}

let toasts: Toast[] = []
let nextId = 1
const listeners = new Set<() => void>()
const emit = () => listeners.forEach((listener) => listener())

export function toast(message: string, options: { tone?: Toast['tone']; action?: Toast['action']; duration?: number } = {}) {
  const id = nextId++
  toasts = [...toasts.slice(-2), { id, message, tone: options.tone ?? 'default', action: options.action }]
  emit()
  setTimeout(() => dismissToast(id), options.duration ?? (options.action ? 6000 : 3000))
}

export function dismissToast(id: number) {
  toasts = toasts.filter((t) => t.id !== id)
  emit()
}

export function useToasts() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => toasts,
    () => toasts,
  )
}
